var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "200px" },
            attrs: { placeholder: "Serial Number" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleFilter.apply(null, arguments)
              },
            },
            model: {
              value: _vm.listQuery.serialNumber,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "serialNumber", $$v)
              },
              expression: "listQuery.serialNumber",
            },
          }),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Product Type", clearable: "" },
              model: {
                value: _vm.listQuery.productType,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "productType", $$v)
                },
                expression: "listQuery.productType",
              },
            },
            [
              _c("el-option", { attrs: { label: "All", value: "" } }),
              _c("el-option", { attrs: { label: "V1", value: "V1" } }),
              _c("el-option", { attrs: { label: "V2", value: "V2" } }),
            ],
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "filter-item",
              staticStyle: { width: "150px" },
              attrs: { placeholder: "Status", clearable: "" },
              model: {
                value: _vm.listQuery.lifecycleStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.listQuery, "lifecycleStatus", $$v)
                },
                expression: "listQuery.lifecycleStatus",
              },
            },
            [
              _c("el-option", { attrs: { label: "All", value: "" } }),
              _c("el-option", { attrs: { label: "Active", value: "ACTIVE" } }),
              _c("el-option", {
                attrs: { label: "Inactive", value: "INACTIVE" },
              }),
              _c("el-option", {
                attrs: { label: "Refunded", value: "REFUNDED" },
              }),
              _c("el-option", {
                attrs: { label: "Replaced", value: "REPLACED" },
              }),
              _c("el-option", { attrs: { label: "Repair", value: "REPAIR" } }),
              _c("el-option", {
                attrs: { label: "Archived", value: "ARCHIVED" },
              }),
            ],
            1
          ),
          _c("el-input", {
            staticClass: "filter-item",
            staticStyle: { width: "240px" },
            attrs: { placeholder: "User ID, e-mail or name", clearable: "" },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleFilter.apply(null, arguments)
              },
            },
            model: {
              value: _vm.listQuery.user,
              callback: function ($$v) {
                _vm.$set(_vm.listQuery, "user", $$v)
              },
              expression: "listQuery.user",
            },
          }),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter },
            },
            [_vm._v(" Search ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "success", icon: "el-icon-plus" },
              on: { click: _vm.handleCreate },
            },
            [_vm._v(" Register Device ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: { type: "warning", icon: "el-icon-upload" },
              on: { click: _vm.handleBulkRegister },
            },
            [_vm._v(" Bulk Register ")]
          ),
          _c(
            "el-button",
            {
              staticClass: "filter-item",
              attrs: {
                type: "info",
                icon: "el-icon-refresh",
                loading: _vm.syncLoading,
              },
              on: {
                click: function ($event) {
                  return _vm.handleSyncMissingFeatures(1)
                },
              },
            },
            [_vm._v(" Sync Missing Features ")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.syncDialogVisible,
            title: "Sync Missing Device Features from Zoho",
            width: "80%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.syncDialogVisible = $event
            },
          },
        },
        [
          _vm.syncResult
            ? [
                _c("el-alert", {
                  staticStyle: { "margin-bottom": "16px" },
                  attrs: {
                    title: `Scan complete: ${_vm.syncResult.total} devices without features found`,
                    type: _vm.syncResult.matched > 0 ? "warning" : "success",
                    closable: false,
                    "show-icon": "",
                  },
                }),
                _vm.syncResult.dryRun &&
                _vm.syncResult.zoho &&
                _vm.syncResult.zoho.nextPage
                  ? _c(
                      "el-alert",
                      {
                        staticStyle: { "margin-bottom": "16px" },
                        attrs: {
                          title: _vm.$t("devicesScreen.zohoCheckedUpTo", {
                            page: _vm.syncResult.zoho.nextPage - 1,
                          }),
                          type: "info",
                          closable: false,
                          "show-icon": "",
                        },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleSyncMissingFeatures(
                                  _vm.syncResult.zoho.nextPage
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("devicesScreen.scanNextZohoPage", {
                                    page: _vm.syncResult.zoho.nextPage,
                                  })
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "el-row",
                  {
                    staticStyle: { "margin-bottom": "16px" },
                    attrs: { gutter: 16 },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-card", { attrs: { shadow: "never" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: { "font-size": "13px" },
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_vm._v("Total Scanned")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "24px",
                                "font-weight": "bold",
                                color: "#409eff",
                              },
                            },
                            [_vm._v(_vm._s(_vm.syncResult.total))]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-card", { attrs: { shadow: "never" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: { "font-size": "13px" },
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_vm._v("Matched in Zoho")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "24px",
                                "font-weight": "bold",
                                color: "#67c23a",
                              },
                            },
                            [_vm._v(_vm._s(_vm.syncResult.matched))]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-card", { attrs: { shadow: "never" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: { "font-size": "13px" },
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [_vm._v("Not Found in Zoho")]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "24px",
                                "font-weight": "bold",
                                color: "#909399",
                              },
                            },
                            [_vm._v(_vm._s(_vm.syncResult.notFoundInZoho))]
                          ),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c("el-card", { attrs: { shadow: "never" } }, [
                          _c(
                            "div",
                            {
                              staticStyle: { "font-size": "13px" },
                              attrs: { slot: "header" },
                              slot: "header",
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.syncResult.dryRun
                                    ? "Will Apply"
                                    : "Applied"
                                )
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "24px",
                                "font-weight": "bold",
                                color: "#e6a23c",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.syncResult.dryRun
                                    ? _vm.syncResult.matched
                                    : _vm.syncResult.updated
                                )
                              ),
                            ]
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm.syncResult.matched > 0 && _vm.syncResult.summary
                  ? [
                      _c(
                        "el-row",
                        {
                          staticStyle: { "margin-bottom": "16px" },
                          attrs: { gutter: 16 },
                        },
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-card",
                                {
                                  attrs: {
                                    shadow: "never",
                                    header: "Device SKU Distribution",
                                  },
                                },
                                _vm._l(
                                  _vm.syncResult.summary.byDeviceSku,
                                  function (count, sku) {
                                    return _c(
                                      "div",
                                      {
                                        key: "d-" + sku,
                                        staticStyle: { "margin-bottom": "4px" },
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          { attrs: { size: "small" } },
                                          [_vm._v(_vm._s(sku))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticStyle: { float: "right" } },
                                          [_vm._v(_vm._s(count))]
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-card",
                                {
                                  attrs: {
                                    shadow: "never",
                                    header: "Addon SKU Distribution",
                                  },
                                },
                                [
                                  _vm._l(
                                    _vm.syncResult.summary.byAddonSku,
                                    function (count, sku) {
                                      return _c(
                                        "div",
                                        {
                                          key: "a-" + sku,
                                          staticStyle: {
                                            "margin-bottom": "4px",
                                          },
                                        },
                                        [
                                          _c(
                                            "el-tag",
                                            {
                                              attrs: {
                                                size: "small",
                                                type: "success",
                                              },
                                            },
                                            [_vm._v(_vm._s(sku))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "span",
                                            { staticStyle: { float: "right" } },
                                            [_vm._v(_vm._s(count))]
                                          ),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  Object.keys(
                                    _vm.syncResult.summary.byAddonSku || {}
                                  ).length === 0
                                    ? _c(
                                        "div",
                                        { staticStyle: { color: "#909399" } },
                                        [_vm._v("No addon SKUs")]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "el-card",
                                {
                                  attrs: {
                                    shadow: "never",
                                    header: "Features to Grant",
                                  },
                                },
                                _vm._l(
                                  _vm.syncResult.summary.featuresByType,
                                  function (count, feat) {
                                    return _c(
                                      "div",
                                      {
                                        key: "f-" + feat,
                                        staticStyle: { "margin-bottom": "4px" },
                                      },
                                      [
                                        _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              size: "small",
                                              type: "warning",
                                            },
                                          },
                                          [_vm._v(_vm._s(feat))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticStyle: { float: "right" } },
                                          [_vm._v(_vm._s(count))]
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-table",
                        {
                          staticStyle: { "margin-bottom": "16px" },
                          attrs: {
                            data: _vm.syncResult.details
                              .filter((d) => d.status !== "not_found_in_zoho")
                              .slice(0, 50),
                            size: "small",
                            border: "",
                            "max-height": "300",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "Serial",
                              prop: "serial",
                              width: "180",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Type",
                              prop: "productType",
                              width: "60",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Status",
                              prop: "lifecycleStatus",
                              width: "90",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "User",
                              width: "60",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            type: row.hasUser
                                              ? "success"
                                              : "info",
                                            size: "mini",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(row.hasUser ? "Yes" : "No")
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2385897917
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Package",
                              prop: "packageNumber",
                              width: "140",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Device SKU",
                              prop: "deviceSku",
                              width: "110",
                            },
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Addon SKUs", width: "200" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _vm._l(row.addonSkus || [], function (s) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: s,
                                            staticStyle: { margin: "2px" },
                                            attrs: {
                                              size: "mini",
                                              type: "success",
                                            },
                                          },
                                          [_vm._v(_vm._s(s))]
                                        )
                                      }),
                                      !row.addonSkus ||
                                      row.addonSkus.length === 0
                                        ? _c("span", [_vm._v("-")])
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3223173328
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Features" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return _vm._l(
                                      row.featuresGranted || [],
                                      function (f) {
                                        return _c(
                                          "el-tag",
                                          {
                                            key: f,
                                            staticStyle: { margin: "2px" },
                                            attrs: {
                                              size: "mini",
                                              type: "warning",
                                            },
                                          },
                                          [_vm._v(_vm._s(f))]
                                        )
                                      }
                                    )
                                  },
                                },
                              ],
                              null,
                              false,
                              3216145007
                            ),
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm.syncResult.dryRun && _vm.syncResult.matched > 0
                  ? _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.syncDialogVisible = false
                              },
                            },
                          },
                          [_vm._v("Cancel")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              loading: _vm.syncApplying,
                            },
                            on: { click: _vm.applySyncFeatures },
                          },
                          [
                            _vm._v(
                              " Apply Features to " +
                                _vm._s(_vm.syncResult.matched) +
                                " Devices "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : !_vm.syncResult.dryRun
                  ? _c(
                      "div",
                      { staticStyle: { "text-align": "right" } },
                      [
                        _c("el-alert", {
                          staticStyle: { "margin-bottom": "12px" },
                          attrs: {
                            title: `Successfully applied features to ${_vm.syncResult.updated} devices`,
                            type: "success",
                            closable: false,
                            "show-icon": "",
                          },
                        }),
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                _vm.syncDialogVisible = false
                                _vm.fetchData()
                              },
                            },
                          },
                          [_vm._v("Close")]
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "right",
                          color: "#67c23a",
                          "margin-top": "12px",
                        },
                      },
                      [
                        _vm._v(
                          " All devices have their features configured correctly. "
                        ),
                        _c(
                          "el-button",
                          {
                            staticStyle: { "margin-left": "12px" },
                            on: {
                              click: function ($event) {
                                _vm.syncDialogVisible = false
                              },
                            },
                          },
                          [_vm._v("Close")]
                        ),
                      ],
                      1
                    ),
              ]
            : _c(
                "div",
                { staticStyle: { "text-align": "center", padding: "40px 0" } },
                [
                  _c("i", {
                    staticClass: "el-icon-loading",
                    staticStyle: { "font-size": "24px" },
                  }),
                  _c("p", [
                    _vm._v("Scanning devices and looking up Zoho packages..."),
                  ]),
                ]
              ),
        ],
        2
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading",
            },
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "Loading...",
            border: "",
            fit: "",
            "highlight-current-row": "",
          },
        },
        [
          _c("el-table-column", {
            attrs: { label: "Serial Number", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("el-tag", { attrs: { type: "info" } }, [
                      _vm._v(_vm._s(row.serialNumber)),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Product Type", align: "center", width: "130" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: { type: _vm.getProductTypeTag(row.productType) },
                      },
                      [_vm._v(" " + _vm._s(row.productType) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Current User", align: "center", width: "220" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.currentUser
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content:
                                _vm.userFullName(row.currentUser) +
                                " • " +
                                row.currentUserId,
                              placement: "top",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "line-height": "1.3" } },
                              [
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "13px",
                                      "font-weight": "500",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.userFullName(row.currentUser) || "-"
                                      )
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      color: "#606266",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        row.currentUser.email ||
                                          row.currentUserId
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                          ]
                        )
                      : row.currentUserId
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-family": "monospace",
                              "font-size": "11px",
                              color: "#909399",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.currentUserId) + " ")]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [_vm._v("Not Connected")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Lifecycle Status", align: "center", width: "140" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          type: _vm.getStatusTagType(row.lifecycleStatus),
                          size: "small",
                        },
                      },
                      [_vm._v(" " + _vm._s(row.lifecycleStatus) + " ")]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Activation Date", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.formatDate(row.activationDate)) + " "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "Warranty", align: "center", width: "150" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    row.warrantyEndDate
                      ? _c(
                          "span",
                          {
                            class: {
                              "warranty-expired": _vm.isWarrantyExpired(
                                row.warrantyEndDate
                              ),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.formatDate(row.warrantyEndDate)) +
                                " "
                            ),
                          ]
                        )
                      : _c(
                          "el-tag",
                          { attrs: { type: "info", size: "mini" } },
                          [_vm._v("N/A")]
                        ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "Actions",
              align: "center",
              width: "170",
              fixed: "right",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tooltip",
                      { attrs: { content: "View", placement: "top" } },
                      [
                        _c("el-button", {
                          attrs: {
                            size: "mini",
                            type: "primary",
                            icon: "el-icon-view",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleView(row)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                    row.currentUserId
                      ? _c(
                          "el-tooltip",
                          {
                            attrs: {
                              content: _vm.$t("devicesScreen.managePins"),
                              placement: "top",
                            },
                          },
                          [
                            _c("el-button", {
                              attrs: {
                                size: "mini",
                                type: "warning",
                                icon: "el-icon-paperclip",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.showPinManager(row)
                                },
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c(
                      "el-dropdown",
                      {
                        staticStyle: { "margin-left": "5px" },
                        on: {
                          command: (command) =>
                            _vm.handleLifecycleAction(command, row),
                        },
                      },
                      [
                        _c(
                          "el-button",
                          { attrs: { size: "mini", type: "info" } },
                          [
                            _vm._v(" More"),
                            _c("i", {
                              staticClass: "el-icon-arrow-down el-icon--right",
                            }),
                          ]
                        ),
                        _c(
                          "el-dropdown-menu",
                          { attrs: { slot: "dropdown" }, slot: "dropdown" },
                          [
                            !row.currentUserId
                              ? _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "connect" } },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-connection",
                                    }),
                                    _vm._v(" Connect "),
                                  ]
                                )
                              : _vm._e(),
                            row.currentUserId
                              ? _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "disconnect" } },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-switch-button",
                                    }),
                                    _vm._v(" Disconnect "),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "features", divided: "" } },
                              [_vm._v("Manage Features")]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "history" } },
                              [_vm._v("View History")]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "lifecycle" } },
                              [_vm._v("Update Status")]
                            ),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "purchaseType" } },
                              [_vm._v("Set Purchase Type")]
                            ),
                            row.lifecycleStatus === "ACTIVE"
                              ? _c(
                                  "el-dropdown-item",
                                  {
                                    attrs: {
                                      command: "startRepair",
                                      divided: "",
                                    },
                                  },
                                  [
                                    _c("i", { staticClass: "el-icon-s-tools" }),
                                    _vm._v(" Send for Repair "),
                                  ]
                                )
                              : _vm._e(),
                            row.lifecycleStatus === "REPAIR"
                              ? _c(
                                  "el-dropdown-item",
                                  { attrs: { command: "completeRepair" } },
                                  [
                                    _c("i", { staticClass: "el-icon-check" }),
                                    _vm._v(" Complete Repair "),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "el-dropdown-item",
                              { attrs: { command: "replace", divided: "" } },
                              [
                                _c("i", { staticClass: "el-icon-refresh" }),
                                _vm._v(" Replace Device "),
                              ]
                            ),
                            row.lifecycleStatus !== "REFUNDED"
                              ? _c(
                                  "el-dropdown-item",
                                  {
                                    staticStyle: { color: "#f56c6c" },
                                    attrs: { command: "refund" },
                                  },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-sold-out",
                                    }),
                                    _vm._v(" Process Refund "),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total>0",
          },
        ],
        attrs: {
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
      _c(
        "el-dialog",
        {
          attrs: {
            title:
              _vm.dialogStatus === "create"
                ? "Register New Device"
                : "Device Details",
            visible: _vm.dialogFormVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "dataForm",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-width": "150px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Serial Number", prop: "serialNumber" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "SN123456" },
                    model: {
                      value: _vm.formData.serialNumber,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "serialNumber", $$v)
                      },
                      expression: "formData.serialNumber",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Product Type", prop: "productType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Select product type" },
                      model: {
                        value: _vm.formData.productType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "productType", $$v)
                        },
                        expression: "formData.productType",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "V1", value: "V1" } }),
                      _c("el-option", { attrs: { label: "V2", value: "V2" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Purchase Type", prop: "purchaseType" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Select purchase type" },
                      model: {
                        value: _vm.formData.purchaseType,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "purchaseType", $$v)
                        },
                        expression: "formData.purchaseType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Pre-Order", value: "PRE_ORDER" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Regular", value: "REGULAR" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Distributor", value: "DISTRIBUTOR" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Other", value: "OTHER" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Demo", value: "DEMO" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Purchase Date" } },
                [
                  _c("el-date-picker", {
                    attrs: { type: "date", placeholder: "Select date" },
                    model: {
                      value: _vm.formData.purchaseDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "purchaseDate", $$v)
                      },
                      expression: "formData.purchaseDate",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Warranty Period" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        placeholder: "Select warranty period",
                        clearable: "",
                      },
                      model: {
                        value: _vm.formData.warrantyPeriodId,
                        callback: function ($$v) {
                          _vm.$set(_vm.formData, "warrantyPeriodId", $$v)
                        },
                        expression: "formData.warrantyPeriodId",
                      },
                    },
                    _vm._l(_vm.warrantyPeriods, function (period) {
                      return _c("el-option", {
                        key: period.id,
                        attrs: {
                          label: `${period.name} (${period.durationMonths} months)`,
                          value: period.id,
                        },
                      })
                    }),
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        "font-size": "12px",
                        color: "#909399",
                        "margin-top": "5px",
                      },
                    },
                    [_vm._v(" Or set manual warranty end date below ")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Warranty End Date" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "date",
                      placeholder: "Select date (overrides period)",
                      disabled: !!_vm.formData.warrantyPeriodId,
                    },
                    model: {
                      value: _vm.formData.warrantyEndDate,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "warrantyEndDate", $$v)
                      },
                      expression: "formData.warrantyEndDate",
                    },
                  }),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("Device Features"),
              ]),
              _c("el-form-item", { attrs: { label: "Add Feature" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      gap: "10px",
                      "flex-wrap": "wrap",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "Select feature" },
                        model: {
                          value: _vm.newFeature.featureKey,
                          callback: function ($$v) {
                            _vm.$set(_vm.newFeature, "featureKey", $$v)
                          },
                          expression: "newFeature.featureKey",
                        },
                      },
                      _vm._l(_vm.featuresList, function (feature) {
                        return _c("el-option", {
                          key: feature.featureKey,
                          attrs: {
                            label: feature.name,
                            value: feature.featureKey,
                          },
                        })
                      }),
                      1
                    ),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "130px" },
                        attrs: { placeholder: "Duration type" },
                        model: {
                          value: _vm.newFeature.durationType,
                          callback: function ($$v) {
                            _vm.$set(_vm.newFeature, "durationType", $$v)
                          },
                          expression: "newFeature.durationType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "Permanent", value: "permanent" },
                        }),
                        _c("el-option", {
                          attrs: { label: "Days", value: "days" },
                        }),
                        _c("el-option", {
                          attrs: { label: "Months", value: "months" },
                        }),
                        _c("el-option", {
                          attrs: { label: "Years", value: "years" },
                        }),
                      ],
                      1
                    ),
                    _vm.newFeature.durationType !== "permanent"
                      ? _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: { min: 1, max: 100 },
                          model: {
                            value: _vm.newFeature.durationValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.newFeature, "durationValue", $$v)
                            },
                            expression: "newFeature.durationValue",
                          },
                        })
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.addFeatureToForm },
                      },
                      [_vm._v(" Add ")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm.formData.features.length > 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Features" } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.formData.features,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "Feature", align: "left" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFeatureName(row.featureKey)
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2717045624
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Duration",
                              align: "center",
                              width: "150",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.formatDuration(
                                              row.durationType,
                                              row.durationValue
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              4150968568
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: {
                              label: "Action",
                              align: "center",
                              width: "80",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ $index }) {
                                    return [
                                      _c("el-button", {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          icon: "el-icon-delete",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeFeatureFromForm(
                                              $index
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3714320727
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "Zoho Order ID" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "ZO12345" },
                    model: {
                      value: _vm.formData.zohoOrderId,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "zohoOrderId", $$v)
                      },
                      expression: "formData.zohoOrderId",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Notes" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "Additional notes",
                    },
                    model: {
                      value: _vm.formData.notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.formData, "notes", $$v)
                      },
                      expression: "formData.notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFormVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveDevice } },
                [_vm._v("Confirm")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Connect Device to User",
            visible: _vm.dialogConnectVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogConnectVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "connectForm",
              attrs: { model: _vm.connectData, "label-width": "120px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Device SN" } },
                [_c("el-tag", [_vm._v(_vm._s(_vm.connectData.serialNumber))])],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "User ID", prop: "userId" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "user123" },
                    model: {
                      value: _vm.connectData.userId,
                      callback: function ($$v) {
                        _vm.$set(_vm.connectData, "userId", $$v)
                      },
                      expression: "connectData.userId",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogConnectVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmConnect },
                },
                [_vm._v("Connect")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Disconnect Device",
            visible: _vm.dialogDisconnectVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogDisconnectVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.disconnectData, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Device SN" } },
                [
                  _c("el-tag", [
                    _vm._v(_vm._s(_vm.disconnectData.serialNumber)),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Current User" } },
                [
                  _c("el-tag", { attrs: { type: "warning" } }, [
                    _vm._v(_vm._s(_vm.disconnectData.currentUserId)),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "Reason for disconnection",
                    },
                    model: {
                      value: _vm.disconnectData.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.disconnectData, "reason", $$v)
                      },
                      expression: "disconnectData.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogDisconnectVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning" },
                  on: { click: _vm.confirmDisconnect },
                },
                [_vm._v("Disconnect")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Update Device Lifecycle",
            visible: _vm.dialogLifecycleVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogLifecycleVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.lifecycleData, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Device SN" } },
                [
                  _c("el-tag", [
                    _vm._v(_vm._s(_vm.lifecycleData.serialNumber)),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "New Status" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Select status" },
                      model: {
                        value: _vm.lifecycleData.status,
                        callback: function ($$v) {
                          _vm.$set(_vm.lifecycleData, "status", $$v)
                        },
                        expression: "lifecycleData.status",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Active", value: "ACTIVE" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Inactive", value: "INACTIVE" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Refunded", value: "REFUNDED" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Replaced", value: "REPLACED" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Repair", value: "REPAIR" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Archived", value: "ARCHIVED" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "Reason for status change",
                    },
                    model: {
                      value: _vm.lifecycleData.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.lifecycleData, "reason", $$v)
                      },
                      expression: "lifecycleData.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogLifecycleVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmLifecycleUpdate },
                },
                [_vm._v("Update")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Set Purchase Type",
            visible: _vm.dialogPurchaseTypeVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogPurchaseTypeVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.purchaseTypeData, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Device SN" } },
                [
                  _c("el-tag", [
                    _vm._v(_vm._s(_vm.purchaseTypeData.serialNumber)),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Purchase Type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Select purchase type" },
                      model: {
                        value: _vm.purchaseTypeData.purchaseType,
                        callback: function ($$v) {
                          _vm.$set(_vm.purchaseTypeData, "purchaseType", $$v)
                        },
                        expression: "purchaseTypeData.purchaseType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Pre-Order", value: "PRE_ORDER" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Regular", value: "REGULAR" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Distributor", value: "DISTRIBUTOR" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Other", value: "OTHER" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Demo", value: "DEMO" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.purchaseTypeData.purchaseType === "DEMO"
                ? _c("el-alert", {
                    attrs: {
                      type: "info",
                      closable: false,
                      title:
                        "Each holder of a demo cane gets its features for 14 days, renewed while they keep connecting it, and no warranty. The current holder is moved onto these terms now.",
                    },
                  })
                : _vm._e(),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-top": "12px" },
                  attrs: { label: "Reason" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "Reason for the change",
                    },
                    model: {
                      value: _vm.purchaseTypeData.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.purchaseTypeData, "reason", $$v)
                      },
                      expression: "purchaseTypeData.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogPurchaseTypeVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmPurchaseTypeUpdate },
                },
                [_vm._v("Update")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Replace Device",
            visible: _vm.dialogReplaceVisible,
            width: "600px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogReplaceVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.replaceData, "label-width": "150px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Old Device SN" } },
                [
                  _c("el-tag", [
                    _vm._v(_vm._s(_vm.replaceData.oldSerialNumber)),
                  ]),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "New Device SN" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        filterable: "",
                        remote: "",
                        "reserve-keyword": "",
                        placeholder: "Search by serial number...",
                        "remote-method": _vm.searchReplacementDevices,
                        loading: _vm.replaceSearchLoading,
                      },
                      on: { change: _vm.onReplacementDeviceSelected },
                      model: {
                        value: _vm.replaceData.newSerialNumber,
                        callback: function ($$v) {
                          _vm.$set(_vm.replaceData, "newSerialNumber", $$v)
                        },
                        expression: "replaceData.newSerialNumber",
                      },
                    },
                    _vm._l(_vm.replaceSearchResults, function (device) {
                      return _c(
                        "el-option",
                        {
                          key: device.serialNumber,
                          attrs: {
                            label: device.serialNumber,
                            value: device.serialNumber,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "flex",
                                "justify-content": "space-between",
                                "align-items": "center",
                              },
                            },
                            [
                              _c("span", [_vm._v(_vm._s(device.serialNumber))]),
                              _c(
                                "span",
                                { staticStyle: { "margin-left": "12px" } },
                                [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        size: "mini",
                                        type: _vm.getProductTypeTag(
                                          device.productType
                                        ),
                                      },
                                    },
                                    [_vm._v(_vm._s(device.productType))]
                                  ),
                                  _c(
                                    "el-tag",
                                    {
                                      staticStyle: { "margin-left": "4px" },
                                      attrs: {
                                        size: "mini",
                                        type: _vm.getStatusTagType(
                                          device.lifecycleStatus
                                        ),
                                      },
                                    },
                                    [_vm._v(_vm._s(device.lifecycleStatus))]
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "New Product Type" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "Select product type" },
                      model: {
                        value: _vm.replaceData.newProductType,
                        callback: function ($$v) {
                          _vm.$set(_vm.replaceData, "newProductType", $$v)
                        },
                        expression: "replaceData.newProductType",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "V1", value: "V1" } }),
                      _c("el-option", { attrs: { label: "V2", value: "V2" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Reason" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder: "Reason for replacement",
                    },
                    model: {
                      value: _vm.replaceData.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.replaceData, "reason", $$v)
                      },
                      expression: "replaceData.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogReplaceVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning" },
                  on: { click: _vm.confirmReplace },
                },
                [_vm._v("Replace")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Device Details",
            visible: _vm.dialogViewVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogViewVisible = $event
            },
          },
        },
        [
          _c(
            "el-descriptions",
            { attrs: { column: 2, border: "" } },
            [
              _c("el-descriptions-item", { attrs: { label: "ID" } }, [
                _vm._v(_vm._s(_vm.viewData.id)),
              ]),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Serial Number" } },
                [_c("el-tag", [_vm._v(_vm._s(_vm.viewData.serialNumber))])],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Product Type" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getProductTypeTag(_vm.viewData.productType),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.viewData.productType) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Purchase Type" } },
                [_vm._v(" " + _vm._s(_vm.viewData.purchaseType) + " ")]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Current User", span: 2 } },
                [
                  _vm.viewData.currentUser
                    ? [
                        _c("div", { staticStyle: { "line-height": "1.4" } }, [
                          _c("div", [
                            _vm._v(
                              _vm._s(
                                _vm.viewData.currentUser.email ||
                                  _vm.viewData.currentUserId
                              )
                            ),
                          ]),
                          _vm.viewData.currentUser.firstName ||
                          _vm.viewData.currentUser.lastName
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    "font-size": "11px",
                                    color: "#909399",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.userFullName(
                                          _vm.viewData.currentUser
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "font-size": "11px",
                                color: "#c0c4cc",
                                "font-family": "monospace",
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.viewData.currentUserId) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    : _vm.viewData.currentUserId
                    ? _c(
                        "span",
                        { staticStyle: { "font-family": "monospace" } },
                        [_vm._v(" " + _vm._s(_vm.viewData.currentUserId) + " ")]
                      )
                    : _c("el-tag", { attrs: { type: "info", size: "small" } }, [
                        _vm._v("Not Connected"),
                      ]),
                ],
                2
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Lifecycle Status" } },
                [
                  _c(
                    "el-tag",
                    {
                      attrs: {
                        type: _vm.getStatusTagType(
                          _vm.viewData.lifecycleStatus
                        ),
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.viewData.lifecycleStatus) + " ")]
                  ),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Zoho Order ID" } },
                [_vm._v(" " + _vm._s(_vm.viewData.zohoOrderId || "N/A") + " ")]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Purchase Date" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatDate(_vm.viewData.purchaseDate)) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Activation Date" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatDate(_vm.viewData.activationDate)) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Warranty Period" } },
                [
                  _vm.viewData.warrantyPeriod
                    ? _c("el-tag", { attrs: { type: "info" } }, [
                        _vm._v(
                          " " + _vm._s(_vm.viewData.warrantyPeriod.name) + " "
                        ),
                      ])
                    : _c("span", [_vm._v("N/A")]),
                ],
                1
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Warranty End Date" } },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.formatDate(_vm.viewData.warrantyEndDate)) +
                      " "
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Created At", span: 2 } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.formatDate(_vm.viewData.createdAt)) + " "
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Updated At", span: 2 } },
                [
                  _vm._v(
                    " " + _vm._s(_vm.formatDate(_vm.viewData.updatedAt)) + " "
                  ),
                ]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Notes", span: 2 } },
                [_vm._v(" " + _vm._s(_vm.viewData.notes || "N/A") + " ")]
              ),
              _c(
                "el-descriptions-item",
                { attrs: { label: "Metadata", span: 2 } },
                [
                  _c(
                    "pre",
                    {
                      staticStyle: {
                        background: "#f5f5f5",
                        padding: "10px",
                        "border-radius": "4px",
                        "max-height": "200px",
                        overflow: "auto",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          JSON.stringify(_vm.viewData.metadataJson, null, 2)
                        )
                      ),
                    ]
                  ),
                ]
              ),
            ],
            1
          ),
          _c("el-divider", { attrs: { "content-position": "left" } }, [
            _vm._v("Device Features"),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingFeatures,
                  expression: "loadingFeatures",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.deviceFeatures, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Feature", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(row.feature?.name || row.featureKey) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Duration", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatDuration(
                                row.durationType,
                                row.durationValue
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Status", align: "center", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getFeatureStatusType(row),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.getFeatureStatus(row)) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "End Date", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.endDate ? _vm.formatDate(row.endDate) : "N/A"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.deviceFeatures.length === 0 && !_vm.loadingFeatures
            ? _c("el-empty", {
                attrs: {
                  description: "No features assigned",
                  "image-size": 80,
                },
              })
            : _vm._e(),
          _c("el-divider", { attrs: { "content-position": "left" } }, [
            _vm._v("OTA Pinleri"),
          ]),
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.viewPinLoading,
                  expression: "viewPinLoading",
                },
              ],
            },
            [
              _c("pin-list", {
                attrs: {
                  pins: _vm.viewPinList,
                  "removing-key": _vm.viewPinRemovingKey,
                },
                on: { remove: _vm.removePinFromView },
              }),
              _vm.viewData.currentUserId && _vm.viewUserDevices.length
                ? _c("pin-form", {
                    key: "view-" + _vm.viewData.serialNumber,
                    attrs: {
                      "user-id": _vm.viewData.currentUserId,
                      "user-devices": _vm.viewUserDevices,
                      "user-pins": _vm.viewAllUserPins,
                      "locked-device-serial": _vm.viewData.serialNumber,
                      "available-ota-files": _vm.viewAvailableOtaFiles,
                      "allow-user-scope": false,
                    },
                    on: { saved: _vm.onViewPinSaved },
                  })
                : !_vm.viewData.currentUserId
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#909399",
                        "font-size": "12px",
                        padding: "6px 0",
                      },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("devicesScreen.deviceNotBound")) +
                          " "
                      ),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-dropdown",
                {
                  staticStyle: { "margin-right": "8px" },
                  on: {
                    command: (cmd) =>
                      _vm.handleLifecycleAction(cmd, _vm.viewData),
                  },
                },
                [
                  _c("el-button", { attrs: { size: "small", type: "info" } }, [
                    _vm._v(" More "),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right",
                    }),
                  ]),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      !_vm.viewData.currentUserId
                        ? _c(
                            "el-dropdown-item",
                            { attrs: { command: "connect" } },
                            [
                              _c("i", { staticClass: "el-icon-connection" }),
                              _vm._v(" Connect "),
                            ]
                          )
                        : _vm._e(),
                      _vm.viewData.currentUserId
                        ? _c(
                            "el-dropdown-item",
                            { attrs: { command: "disconnect" } },
                            [
                              _c("i", { staticClass: "el-icon-switch-button" }),
                              _vm._v(" Disconnect "),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "features", divided: "" } },
                        [_vm._v("Manage Features")]
                      ),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "history" } },
                        [_vm._v("View History")]
                      ),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "lifecycle" } },
                        [_vm._v("Update Status")]
                      ),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "purchaseType" } },
                        [_vm._v("Set Purchase Type")]
                      ),
                      _vm.viewData.lifecycleStatus === "ACTIVE"
                        ? _c(
                            "el-dropdown-item",
                            { attrs: { command: "startRepair", divided: "" } },
                            [
                              _c("i", { staticClass: "el-icon-s-tools" }),
                              _vm._v(" Send for Repair "),
                            ]
                          )
                        : _vm._e(),
                      _vm.viewData.lifecycleStatus === "REPAIR"
                        ? _c(
                            "el-dropdown-item",
                            { attrs: { command: "completeRepair" } },
                            [
                              _c("i", { staticClass: "el-icon-check" }),
                              _vm._v(" Complete Repair "),
                            ]
                          )
                        : _vm._e(),
                      _c(
                        "el-dropdown-item",
                        { attrs: { command: "replace", divided: "" } },
                        [_vm._v("Replace")]
                      ),
                      _c("el-dropdown-item", { attrs: { command: "refund" } }, [
                        _vm._v("Refund"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogViewVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Manage Device Features",
            visible: _vm.dialogFeaturesVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFeaturesVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("el-tag", { attrs: { type: "info", size: "medium" } }, [
                _vm._v("Device: " + _vm._s(_vm.viewDeviceSerialNumber)),
              ]),
            ],
            1
          ),
          _c(
            "el-card",
            {
              staticStyle: { "margin-bottom": "20px" },
              attrs: { shadow: "never" },
            },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [_vm._v("Add New Feature")]),
              ]),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    gap: "10px",
                    "flex-wrap": "wrap",
                    "align-items": "center",
                  },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "200px" },
                      attrs: { placeholder: "Select feature" },
                      model: {
                        value: _vm.newFeature.featureKey,
                        callback: function ($$v) {
                          _vm.$set(_vm.newFeature, "featureKey", $$v)
                        },
                        expression: "newFeature.featureKey",
                      },
                    },
                    _vm._l(_vm.featuresList, function (feature) {
                      return _c("el-option", {
                        key: feature.featureKey,
                        attrs: {
                          label: feature.name,
                          value: feature.featureKey,
                        },
                      })
                    }),
                    1
                  ),
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "130px" },
                      attrs: { placeholder: "Duration type" },
                      model: {
                        value: _vm.newFeature.durationType,
                        callback: function ($$v) {
                          _vm.$set(_vm.newFeature, "durationType", $$v)
                        },
                        expression: "newFeature.durationType",
                      },
                    },
                    [
                      _c("el-option", {
                        attrs: { label: "Permanent", value: "permanent" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Days", value: "days" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Months", value: "months" },
                      }),
                      _c("el-option", {
                        attrs: { label: "Years", value: "years" },
                      }),
                    ],
                    1
                  ),
                  _vm.newFeature.durationType !== "permanent"
                    ? _c("el-input-number", {
                        staticStyle: { width: "100px" },
                        attrs: { min: 1, max: 100 },
                        model: {
                          value: _vm.newFeature.durationValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.newFeature, "durationValue", $$v)
                          },
                          expression: "newFeature.durationValue",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleAddFeatureToDevice },
                    },
                    [_vm._v(" Add Feature ")]
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loadingFeatures,
                  expression: "loadingFeatures",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.deviceFeatures, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Feature", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("strong", [
                          _vm._v(_vm._s(row.feature?.name || "Unknown")),
                        ]),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              color: "#909399",
                            },
                          },
                          [_vm._v(_vm._s(row.feature?.featureKey))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Duration", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatDuration(
                                row.durationType,
                                row.durationValue
                              )
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Status", align: "center", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getFeatureStatusType(row),
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.getFeatureStatus(row)) + " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "End Date", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              row.endDate ? _vm.formatDate(row.endDate) : "N/A"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Actions", align: "center", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c("el-button", {
                          attrs: {
                            type: "danger",
                            size: "mini",
                            icon: "el-icon-delete",
                            circle: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.handleRemoveDeviceFeature(row)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm.deviceFeatures.length === 0 && !_vm.loadingFeatures
            ? _c("el-empty", {
                attrs: {
                  description: "No features assigned",
                  "image-size": 100,
                },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogFeaturesVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Device History",
            visible: _vm.dialogHistoryVisible,
            width: "900px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogHistoryVisible = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.historyData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { label: "Event Type", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getEventTypeTag(row.eventType),
                              size: "small",
                            },
                          },
                          [_vm._v(" " + _vm._s(row.eventType) + " ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "User ID", align: "center", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(" " + _vm._s(row.userId || "N/A") + " ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Event Date", align: "center", width: "180" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(row.eventDate)) + " "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "Notes", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [_vm._v(" " + _vm._s(row.notes) + " ")]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogHistoryVisible = false
                    },
                  },
                },
                [_vm._v("Close")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Bulk Register Devices with SKU",
            visible: _vm.dialogBulkVisible,
            width: "800px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogBulkVisible = $event
            },
          },
        },
        [
          _c(
            "el-steps",
            {
              staticStyle: { "margin-bottom": "30px" },
              attrs: { active: _vm.bulkImportStep, "finish-status": "success" },
            },
            [
              _c("el-step", { attrs: { title: "Upload Excel" } }),
              _c("el-step", { attrs: { title: "Validate SKUs" } }),
              _c("el-step", { attrs: { title: "Register Devices" } }),
            ],
            1
          ),
          _vm.bulkImportStep === 0
            ? _c(
                "div",
                [
                  _c(
                    "el-alert",
                    {
                      staticStyle: { "margin-bottom": "20px" },
                      attrs: {
                        title: "Upload Excel file with device data",
                        type: "info",
                        closable: false,
                      },
                    },
                    [
                      _c("div", [
                        _vm._v("Required columns: "),
                        _c("strong", [_vm._v("Serial Number")]),
                        _vm._v(", "),
                        _c("strong", [_vm._v("SKU")]),
                      ]),
                      _c("div", { staticStyle: { "margin-top": "5px" } }, [
                        _vm._v("Optional columns: "),
                        _c("strong", [_vm._v("Date")]),
                        _vm._v(", "),
                        _c("strong", [_vm._v("Name")]),
                        _vm._v(" (or First Name + Last Name), "),
                        _c("strong", [_vm._v("Email")]),
                        _vm._v(", "),
                        _c("strong", [_vm._v("Phone")]),
                        _vm._v(", "),
                        _c("strong", [_vm._v("Country Code")]),
                        _vm._v(", "),
                        _c("strong", [_vm._v("Country")]),
                      ]),
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "margin-top": "5px",
                            color: "#909399",
                            "font-size": "12px",
                          },
                        },
                        [
                          _vm._v(
                            'Note: "Name" column will be automatically split (last word = surname)'
                          ),
                        ]
                      ),
                      _c("div", { staticStyle: { "margin-top": "5px" } }, [
                        _vm._v(
                          "The system will validate SKUs before registering devices."
                        ),
                      ]),
                    ]
                  ),
                  _c("upload-excel", {
                    attrs: {
                      "before-upload": _vm.beforeExcelUpload,
                      "on-success": _vm.handleExcelSuccess,
                    },
                  }),
                  _vm.excelData.length > 0
                    ? _c(
                        "div",
                        { staticStyle: { "margin-top": "20px" } },
                        [
                          _c(
                            "el-divider",
                            { attrs: { "content-position": "left" } },
                            [
                              _vm._v(
                                "Preview (" +
                                  _vm._s(_vm.excelData.length) +
                                  " devices)"
                              ),
                            ]
                          ),
                          _c(
                            "el-table",
                            {
                              attrs: {
                                data: _vm.excelData.slice(0, 10),
                                border: "",
                                size: "small",
                                "max-height": "300",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: {
                                  label: "Serial Number",
                                  prop: "serialNumber",
                                  width: "150",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "SKU",
                                  prop: "skuCode",
                                  width: "150",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Date",
                                  prop: "purchaseDate",
                                  width: "100",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "First Name",
                                  prop: "purchaserFirstName",
                                  width: "100",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Last Name",
                                  prop: "purchaserLastName",
                                  width: "100",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Email",
                                  prop: "purchaserEmail",
                                  width: "180",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Phone",
                                  prop: "purchaserPhone",
                                  width: "120",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Country",
                                  prop: "purchaserCountry",
                                  width: "100",
                                },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  label: "Address",
                                  prop: "purchaserAddress",
                                  width: "200",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.excelData.length > 10
                            ? _c(
                                "div",
                                {
                                  staticStyle: {
                                    color: "#909399",
                                    "margin-top": "10px",
                                  },
                                },
                                [
                                  _vm._v(
                                    " ... and " +
                                      _vm._s(_vm.excelData.length - 10) +
                                      " more devices "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.bulkImportStep === 1
            ? _c("div", [
                _vm.bulkValidating
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          padding: "40px",
                        },
                      },
                      [
                        _c("i", {
                          staticClass: "el-icon-loading",
                          staticStyle: {
                            "font-size": "40px",
                            color: "#409EFF",
                          },
                        }),
                        _c("div", { staticStyle: { "margin-top": "20px" } }, [
                          _vm._v("Validating SKU codes..."),
                        ]),
                      ]
                    )
                  : _vm.missingSkus.length > 0
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-alert",
                          {
                            staticStyle: { "margin-bottom": "20px" },
                            attrs: {
                              title: "Missing SKUs Detected",
                              type: "warning",
                              closable: false,
                            },
                          },
                          [
                            _vm._v(
                              " The following SKU codes do not exist in the system. Please create them before proceeding. "
                            ),
                          ]
                        ),
                        _c(
                          "el-table",
                          {
                            attrs: {
                              data: _vm.missingSkus,
                              border: "",
                              size: "small",
                            },
                          },
                          [
                            _c("el-table-column", {
                              attrs: {
                                label: "SKU Code",
                                prop: "skuCode",
                                width: "200",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: {
                                label: "Device Count",
                                prop: "count",
                                width: "120",
                              },
                            }),
                            _c("el-table-column", {
                              attrs: { label: "Status", width: "120" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        row.created
                                          ? _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: "success",
                                                  size: "small",
                                                },
                                              },
                                              [_vm._v("Created")]
                                            )
                                          : _c(
                                              "el-tag",
                                              {
                                                attrs: {
                                                  type: "danger",
                                                  size: "small",
                                                },
                                              },
                                              [_vm._v("Missing")]
                                            ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                401317026
                              ),
                            }),
                            _c("el-table-column", {
                              attrs: { label: "Action" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function ({ row }) {
                                      return [
                                        !row.created
                                          ? _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "mini",
                                                  type: "primary",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleCreateMissingSku(
                                                      row
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(" Create SKU ")]
                                            )
                                          : _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#67C23A",
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass: "el-icon-check",
                                                }),
                                                _vm._v(" Ready "),
                                              ]
                                            ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3604418560
                              ),
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c(
                          "el-result",
                          {
                            attrs: {
                              icon: "success",
                              title: "All SKUs Validated",
                            },
                          },
                          [
                            _c(
                              "template",
                              { slot: "extra" },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "20px" } },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "All " +
                                          _vm._s(_vm.validatedSkuCount) +
                                          " SKU codes exist in the system."
                                      ),
                                    ]),
                                    _c(
                                      "p",
                                      {
                                        staticStyle: {
                                          color: "#909399",
                                          "font-size": "14px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.excelData.length) +
                                            " records will create " +
                                            _vm._s(_vm.uniqueDeviceCount) +
                                            " unique devices "
                                        ),
                                        _vm.excelData.length >
                                        _vm.uniqueDeviceCount
                                          ? _c("span", [
                                              _vm._v(
                                                " (" +
                                                  _vm._s(
                                                    _vm.excelData.length -
                                                      _vm.uniqueDeviceCount
                                                  ) +
                                                  " records are additional SKUs for same devices) "
                                              ),
                                            ])
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.proceedToRegistration },
                                  },
                                  [_vm._v(" Proceed to Registration ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
              ])
            : _vm._e(),
          _vm.bulkImportStep === 2
            ? _c("div", [
                _vm.bulkRegistering
                  ? _c(
                      "div",
                      {
                        staticStyle: {
                          "text-align": "center",
                          padding: "40px",
                        },
                      },
                      [
                        _c("el-progress", {
                          attrs: {
                            percentage: _vm.registrationProgress,
                            "stroke-width": 20,
                            status: "success",
                          },
                        }),
                        _c("div", { staticStyle: { "margin-top": "20px" } }, [
                          _vm._v(
                            "Registering devices... " +
                              _vm._s(_vm.registeredCount) +
                              "/" +
                              _vm._s(_vm.uniqueDeviceCount)
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm.registrationResult
                  ? _c(
                      "div",
                      [
                        _c(
                          "el-result",
                          {
                            attrs: {
                              icon:
                                _vm.registrationResult.failedCount > 0
                                  ? "warning"
                                  : "success",
                              title:
                                _vm.registrationResult.failedCount > 0
                                  ? "Registration Completed with Errors"
                                  : "Registration Successful",
                            },
                          },
                          [
                            _c(
                              "template",
                              { slot: "extra" },
                              [
                                _c(
                                  "div",
                                  { staticStyle: { "margin-bottom": "20px" } },
                                  [
                                    _c(
                                      "el-tag",
                                      {
                                        staticStyle: { "margin-right": "10px" },
                                        attrs: {
                                          type: "success",
                                          size: "medium",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " Success: " +
                                            _vm._s(
                                              _vm.registrationResult
                                                .successCount
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _vm.registrationResult.failedCount > 0
                                      ? _c(
                                          "el-tag",
                                          {
                                            attrs: {
                                              type: "danger",
                                              size: "medium",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " Failed: " +
                                                _vm._s(
                                                  _vm.registrationResult
                                                    .failedCount
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.finishBulkImport },
                                  },
                                  [_vm._v(" Done ")]
                                ),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                        _vm.registrationResult.failed &&
                        _vm.registrationResult.failed.length > 0
                          ? _c(
                              "div",
                              { staticStyle: { "margin-top": "20px" } },
                              [
                                _c(
                                  "el-divider",
                                  { attrs: { "content-position": "left" } },
                                  [_vm._v("Failed Devices")]
                                ),
                                _c(
                                  "el-table",
                                  {
                                    attrs: {
                                      data: _vm.registrationResult.failed,
                                      border: "",
                                      size: "small",
                                      "max-height": "200",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "Serial Number",
                                        width: "200",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function ({ row }) {
                                              return [
                                                _vm._v(
                                                  _vm._s(
                                                    row.device?.serialNumber ||
                                                      row.serialNumber
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1229478226
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: { label: "Error", prop: "error" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogBulkVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm.bulkImportStep === 0 && _vm.excelData.length > 0
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.validateSkusAndProceed },
                    },
                    [_vm._v(" Validate & Continue ")]
                  )
                : _vm._e(),
              _vm.bulkImportStep === 1 &&
              _vm.missingSkus.length > 0 &&
              _vm.allMissingSkusCreated
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.proceedToRegistration },
                    },
                    [_vm._v(" Continue to Registration ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Create SKU",
            visible: _vm.dialogCreateSkuVisible,
            width: "600px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogCreateSkuVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "skuForm",
              attrs: {
                model: _vm.newSkuForm,
                rules: _vm.skuRules,
                "label-width": "120px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "SKU Code", prop: "skuCode" } },
                [
                  _c("el-input", {
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.newSkuForm.skuCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.newSkuForm, "skuCode", $$v)
                      },
                      expression: "newSkuForm.skuCode",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Name", prop: "name" } },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: "e.g., WeWalk V2 Plus with 1 Year VA",
                    },
                    model: {
                      value: _vm.newSkuForm.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.newSkuForm, "name", $$v)
                      },
                      expression: "newSkuForm.name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Description" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "Brief description of this SKU",
                    },
                    model: {
                      value: _vm.newSkuForm.description,
                      callback: function ($$v) {
                        _vm.$set(_vm.newSkuForm, "description", $$v)
                      },
                      expression: "newSkuForm.description",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Product Type", prop: "productType" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { placeholder: "Select product type" },
                      model: {
                        value: _vm.newSkuForm.productType,
                        callback: function ($$v) {
                          _vm.$set(_vm.newSkuForm, "productType", $$v)
                        },
                        expression: "newSkuForm.productType",
                      },
                    },
                    [
                      _c("el-option", { attrs: { label: "V1", value: "V1" } }),
                      _c("el-option", { attrs: { label: "V2", value: "V2" } }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("el-divider", { attrs: { "content-position": "left" } }, [
                _vm._v("Features"),
              ]),
              _c("el-form-item", { attrs: { label: "Add Feature" } }, [
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      gap: "10px",
                      "flex-wrap": "wrap",
                      "align-items": "center",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "180px" },
                        attrs: { placeholder: "Select feature" },
                        model: {
                          value: _vm.newSkuFeature.featureId,
                          callback: function ($$v) {
                            _vm.$set(_vm.newSkuFeature, "featureId", $$v)
                          },
                          expression: "newSkuFeature.featureId",
                        },
                      },
                      _vm._l(_vm.featuresList, function (f) {
                        return _c("el-option", {
                          key: f.id,
                          attrs: { label: f.name, value: f.id },
                        })
                      }),
                      1
                    ),
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "120px" },
                        attrs: { placeholder: "Duration" },
                        model: {
                          value: _vm.newSkuFeature.durationType,
                          callback: function ($$v) {
                            _vm.$set(_vm.newSkuFeature, "durationType", $$v)
                          },
                          expression: "newSkuFeature.durationType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "Permanent", value: "permanent" },
                        }),
                        _c("el-option", {
                          attrs: { label: "Days", value: "days" },
                        }),
                        _c("el-option", {
                          attrs: { label: "Months", value: "months" },
                        }),
                        _c("el-option", {
                          attrs: { label: "Years", value: "years" },
                        }),
                      ],
                      1
                    ),
                    _vm.newSkuFeature.durationType !== "permanent"
                      ? _c("el-input-number", {
                          staticStyle: { width: "100px" },
                          attrs: { min: 1 },
                          model: {
                            value: _vm.newSkuFeature.durationValue,
                            callback: function ($$v) {
                              _vm.$set(_vm.newSkuFeature, "durationValue", $$v)
                            },
                            expression: "newSkuFeature.durationValue",
                          },
                        })
                      : _vm._e(),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "small" },
                        on: { click: _vm.addFeatureToNewSku },
                      },
                      [_vm._v("Add")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm.newSkuForm.features.length > 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Features" } },
                    [
                      _c(
                        "el-table",
                        {
                          attrs: {
                            data: _vm.newSkuForm.features,
                            border: "",
                            size: "small",
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: { label: "Feature" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getFeatureNameById(
                                              row.featureId
                                            )
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              864668052
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Duration", width: "150" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ row }) {
                                    return [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            row.durationType === "permanent"
                                              ? "Permanent"
                                              : `${row.durationValue} ${row.durationType}`
                                          ) +
                                          " "
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3909357330
                            ),
                          }),
                          _c("el-table-column", {
                            attrs: { label: "Action", width: "80" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ $index }) {
                                    return [
                                      _c("el-button", {
                                        attrs: {
                                          type: "danger",
                                          size: "mini",
                                          icon: "el-icon-delete",
                                          circle: "",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeFeatureFromNewSku(
                                              $index
                                            )
                                          },
                                        },
                                      }),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              228764176
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogCreateSkuVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmCreateSku },
                },
                [_vm._v("Create SKU")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Send Device for Repair",
            visible: _vm.dialogRepairStartVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogRepairStartVisible = $event
            },
          },
        },
        [
          _c(
            "el-alert",
            {
              staticStyle: { "margin-bottom": "20px" },
              attrs: { type: "warning", closable: false },
            },
            [
              _c("div", [_c("strong", [_vm._v("This will:")])]),
              _c("div", [_vm._v("• Disconnect device from current user")]),
              _c("div", [
                _vm._v("• Temporarily revoke user's device-based entitlements"),
              ]),
              _c("div", [_vm._v('• Mark device as "In Repair" status')]),
            ]
          ),
          _c(
            "el-form",
            { attrs: { model: _vm.repairData, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Device SN" } },
                [_c("el-tag", [_vm._v(_vm._s(_vm.repairData.serialNumber))])],
                1
              ),
              _vm.repairData.currentUserId
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Current User" } },
                    [
                      _c("el-tag", { attrs: { type: "warning" } }, [
                        _vm._v(_vm._s(_vm.repairData.currentUserId)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "Reason", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder:
                        "Reason for sending to repair (e.g., Button malfunction, Battery issue)",
                    },
                    model: {
                      value: _vm.repairData.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.repairData, "reason", $$v)
                      },
                      expression: "repairData.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogRepairStartVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "warning" },
                  on: { click: _vm.confirmStartRepair },
                },
                [_vm._v("Send for Repair")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Complete Device Repair",
            visible: _vm.dialogRepairCompleteVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogRepairCompleteVisible = $event
            },
          },
        },
        [
          _c(
            "el-alert",
            {
              staticStyle: { "margin-bottom": "20px" },
              attrs: { type: "success", closable: false },
            },
            [
              _c("div", [_c("strong", [_vm._v("This will:")])]),
              _c("div", [_vm._v('• Mark device as "Active" status')]),
              _c("div", [
                _vm._v("• Extend all feature durations by repair days"),
              ]),
              _c("div", [_vm._v("• Device can be reconnected to user")]),
            ]
          ),
          _c(
            "el-form",
            {
              attrs: { model: _vm.repairCompleteData, "label-width": "140px" },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Device SN" } },
                [
                  _c("el-tag", [
                    _vm._v(_vm._s(_vm.repairCompleteData.serialNumber)),
                  ]),
                ],
                1
              ),
              _vm.repairCompleteData.repairStartDate
                ? _c("el-form-item", { attrs: { label: "Repair Start" } }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.formatDate(_vm.repairCompleteData.repairStartDate)
                        )
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.repairCompleteData.previousUserId
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Previous User" } },
                    [
                      _c("el-tag", { attrs: { type: "info" } }, [
                        _vm._v(_vm._s(_vm.repairCompleteData.previousUserId)),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "Repair Days", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: { min: 0, max: 365 },
                    model: {
                      value: _vm.repairCompleteData.repairDays,
                      callback: function ($$v) {
                        _vm.$set(_vm.repairCompleteData, "repairDays", $$v)
                      },
                      expression: "repairCompleteData.repairDays",
                    },
                  }),
                  _c(
                    "span",
                    {
                      staticStyle: { "margin-left": "10px", color: "#909399" },
                    },
                    [_vm._v("Days to add to feature durations")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "Notes" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 2,
                      placeholder: "Repair notes (optional)",
                    },
                    model: {
                      value: _vm.repairCompleteData.notes,
                      callback: function ($$v) {
                        _vm.$set(_vm.repairCompleteData, "notes", $$v)
                      },
                      expression: "repairCompleteData.notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogRepairCompleteVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "success" },
                  on: { click: _vm.confirmCompleteRepair },
                },
                [_vm._v("Complete Repair")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Process Device Refund",
            visible: _vm.dialogRefundVisible,
            width: "500px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogRefundVisible = $event
            },
          },
        },
        [
          _c(
            "el-alert",
            {
              staticStyle: { "margin-bottom": "20px" },
              attrs: { type: "error", closable: false },
            },
            [
              _c("div", [
                _c("strong", [_vm._v("WARNING: This action is irreversible!")]),
              ]),
              _c("div", [
                _vm._v("• All device features will be permanently reset"),
              ]),
              _c("div", [
                _vm._v("• User's device-based entitlements will be revoked"),
              ]),
              _c("div", [
                _vm._v('• Device status will be marked as "Refunded"'),
              ]),
              _c("div", [
                _vm._v("• Device can be resold as new (features start fresh)"),
              ]),
            ]
          ),
          _c(
            "el-form",
            { attrs: { model: _vm.refundData, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "Device SN" } },
                [
                  _c("el-tag", { attrs: { type: "danger" } }, [
                    _vm._v(_vm._s(_vm.refundData.serialNumber)),
                  ]),
                ],
                1
              ),
              _vm.refundData.currentUserId
                ? _c(
                    "el-form-item",
                    { attrs: { label: "Current User" } },
                    [
                      _c("el-tag", { attrs: { type: "warning" } }, [
                        _vm._v(_vm._s(_vm.refundData.currentUserId)),
                      ]),
                      _c(
                        "span",
                        {
                          staticStyle: {
                            "margin-left": "10px",
                            color: "#f56c6c",
                          },
                        },
                        [_vm._v("Entitlements will be revoked")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "Reason", required: "" } },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      rows: 3,
                      placeholder:
                        "Reason for refund (e.g., Customer request, Defective product)",
                    },
                    model: {
                      value: _vm.refundData.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.refundData, "reason", $$v)
                      },
                      expression: "refundData.reason",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogRefundVisible = false
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _c(
                "el-button",
                { attrs: { type: "danger" }, on: { click: _vm.confirmRefund } },
                [_vm._v("Process Refund")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.pinDrawerVisible,
            title: _vm.pinDrawerTitle,
            direction: "rtl",
            size: "600px",
            "before-close": _vm.closePinDrawer,
          },
          on: {
            "update:visible": function ($event) {
              _vm.pinDrawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.pinDrawerLoading,
                  expression: "pinDrawerLoading",
                },
              ],
              staticStyle: { padding: "0 20px" },
            },
            [
              _vm.pinDrawerDevice
                ? _c("div", { staticStyle: { "margin-bottom": "16px" } }, [
                    _c(
                      "div",
                      [
                        _c("strong", [_vm._v(_vm._s(_vm.$t("otaPin.device")))]),
                        _c("code", { staticStyle: { "margin-left": "6px" } }, [
                          _vm._v(_vm._s(_vm.pinDrawerDevice.serialNumber)),
                        ]),
                        _c(
                          "el-tag",
                          {
                            staticStyle: { "margin-left": "6px" },
                            attrs: { size: "mini", type: "info" },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.pinDrawerDevice.productType) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticStyle: {
                          color: "#909399",
                          "font-size": "12px",
                          "margin-top": "4px",
                        },
                      },
                      [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.$t("devicesScreen.user"))),
                        ]),
                        _vm._v(
                          " " + _vm._s(_vm.pinDrawerDevice.currentUserId) + " "
                        ),
                      ]
                    ),
                    _vm.pinDrawerDevice.installedAppVersion
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              color: "#909399",
                              "font-size": "12px",
                              "margin-top": "4px",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("devicesScreen.installed")) +
                                " "
                            ),
                            _c("strong", [
                              _vm._v(
                                _vm._s(_vm.pinDrawerDevice.installedAppVersion)
                              ),
                            ]),
                            _vm.pinDrawerDevice.installedWirelessVersion
                              ? _c("span", [
                                  _vm._v(
                                    " / " +
                                      _vm._s(
                                        _vm.pinDrawerDevice
                                          .installedWirelessVersion
                                      ) +
                                      " "
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ])
                : _vm._e(),
              _c(
                "h4",
                { staticStyle: { "margin-top": "0", color: "#303133" } },
                [_vm._v(_vm._s(_vm.$t("devicesScreen.pinsOnDevice")))]
              ),
              _c("pin-list", {
                attrs: {
                  pins: _vm.pinDrawerPins,
                  "removing-key": _vm.pinRemovingKey,
                },
                on: { remove: _vm.removePinFromDeviceDrawer },
              }),
              _c(
                "h4",
                { staticStyle: { "margin-top": "20px", color: "#303133" } },
                [_vm._v(_vm._s(_vm.$t("devicesScreen.applyUpdatePin")))]
              ),
              _vm.pinDrawerDevice && _vm.pinDrawerDevice.currentUserId
                ? _c("pin-form", {
                    key: _vm.pinDrawerDevice.id,
                    attrs: {
                      "user-id": _vm.pinDrawerDevice.currentUserId,
                      "user-devices": _vm.pinDrawerUserDevices,
                      "user-pins": _vm.pinDrawerAllUserPins,
                      "locked-device-serial": _vm.pinDrawerDevice.serialNumber,
                      "available-ota-files": _vm.pinDrawerAvailableOtaFiles,
                      "allow-user-scope": false,
                    },
                    on: { saved: _vm.onDevicePinSaved },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }